import {
    createDBInputValidation,
    createDBEntityValidator,
} from 'shared/db/validation/common';
import { Logger } from 'shared/db/validation/databaseInput';
import { createShoppingListSchemas } from 'shared/db/validation/schemas/shoppingList';
import { Validator } from 'shared/db/validation/validator';
import { DeleteRawRecord, UpdateRawRecord } from 'shared/types/rawRecordFields';
import { ShoppingListRawRecord } from 'shared/types/ShoppingList';
import { ShoppingListEntityDBValidation } from 'shared/types/validation';

import { createLoggerFor } from '@/services/logger';
import { getValidationStrategy } from '@/utils/validations';

const schemas = createShoppingListSchemas();

const addValidator = createDBEntityValidator<ShoppingListRawRecord>(
    schemas.add,
);
const updateValidator = createDBEntityValidator<
    UpdateRawRecord<ShoppingListRawRecord>
>(schemas.update);
const deleteValidator = createDBEntityValidator<DeleteRawRecord>(
    schemas.delete,
);

const softValidation = {
    logger: createLoggerFor('db-validation-shopping-lists'),
    hardErrorFields: [],
};

const validationStrategy = getValidationStrategy(softValidation);

export const createShoppingListsInputValidation = <
    T extends Record<string, unknown>,
>(
    validator: Validator<T>,
    softValidation?: {
        logger: Logger;
        hardErrorFields: string[];
    },
) => createDBInputValidation<T>(validator, softValidation);

export const shoppingListsInputValidation: ShoppingListEntityDBValidation = {
    add: createShoppingListsInputValidation(addValidator, validationStrategy),
    update: createShoppingListsInputValidation(
        updateValidator,
        validationStrategy,
    ),
    delete: createShoppingListsInputValidation(
        deleteValidator,
        validationStrategy,
    ),
};
